
import { initialValues, JobFormData, schema } from '@cms/utils/forms/job';
import { ISystemJob } from '@dl/declarations';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { TEAM_OPTIONS } from '../../utils/constants';
import { JobsPath } from '../../utils/routes';
import { ControlledSystemCheckbox } from '../data/Checkbox';
import { ControlledDropdown } from '../data/Dropdown';
import { ControlledStaticInput } from '../data/StaticInput';
import { ControlledSystemTextInput } from '../data/TextInput';
import { JobEditor } from '../editor/Editor';
import { EditorWrapper } from '../editor/EditorWrapper';
import ReadyNodes from '../editor/nodes/ReadyNodes';
import { contentElementsToLexical } from '../editor/utils/helpers';
import { FormContainer } from './FormContainer';

const Form = () => {
    return (
        <div className='flex flex-col items-center md:grid md:grid-cols-2 md:items-start gap-4'>
            <ControlledSystemTextInput
                description='Role'
                name='role'
                required
            />

            <ControlledDropdown
                name='team'
                options={TEAM_OPTIONS}
                valueKey='slug'
                allowSingleDeselect={false}
                description='Team'
                inputSize='full'
                searchOptions={{
                    allow: false,
                }}
            />

            <div className='col-span-full'>
                <ControlledStaticInput
                    name='locations'
                    inputSize='full'
                    description='Locations allowed for the job'
                />
            </div>

            <div className='col-span-full'>
                <JobEditor />
            </div>
            <div className='col-span-full'>
                <ControlledSystemCheckbox
                    name='is_active'
                    label='Active'
                />
            </div>
        </div>
    )
}

const JobFormContent = () => {
    const [editor] = useLexicalComposerContext();

    return (
        <FormContainer<JobFormData>
            title='Job'
            formSize='1/2'
            headerOptions={{
                show: false
            }}
            queryOptions={{
                enabled: true,
                basePath: JobsPath,
                transformData(data: ISystemJob) {
                    contentElementsToLexical(editor, data.content_elements || []);
                    return data
                },
            }}
            schema={schema}
            defaultValues={initialValues}
        >
            <Form />
        </FormContainer>
    )
}

export const JobForm = () => {
    return (
        <EditorWrapper
            initialConfig={{
                editorState: undefined,
                namespace: "JobEditor",
                onError: (error: Error) => {
                    console.error(error);
                },
                nodes: [...ReadyNodes]
            }}
        >
            <JobFormContent />
        </EditorWrapper>
    )
}